import { render, staticRenderFns } from "./UserArticles.vue?vue&type=template&id=49ef25c6&scoped=true"
import script from "./UserArticles.vue?vue&type=script&lang=js"
export * from "./UserArticles.vue?vue&type=script&lang=js"
import style0 from "./UserArticles.vue?vue&type=style&index=0&id=49ef25c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef25c6",
  null
  
)

export default component.exports